export const routes = {
  homepage: '/',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  videoSurveillance: '/vaizdo-stebejimo-taisykles',
  login: '/login',
  promoToken: '/promo/:promoToken',
  registration: '/registration',
  forgotPassword: '/forgot-password',
  passwordReset: '/password-reset/:code',
  registrationConfirmation: '/registration-confirmation/:code',
  reservation: '/reservation',
  profile: '/profile',
  myReservations: '/profile/reservations',
  paymentsHistory: '/profile/payments',
  mySubscriptions: '/profile/subscriptions',
  myCoupons: '/profile/coupons',
  dynamicPage: '/:locale/:slug',
  admin: '/admin',
  users: {
    list: '/admin/users',
    create: '/admin/users/new',
    edit: '/admin/users/:id',
  },
  payments: {
    list: '/admin/payments',
  },
  sessionTypes: '/admin/session-types',
  siteImages: '/admin/site-images',
  promoCodes: '/admin/promo-codes',
  subscriptionTypes: '/admin/subscription-types',
  coupons: '/admin/coupons',
  sessions: '/admin/sessions',
  statistics: '/admin/statistics',
  translations: '/admin/translations',
  languages: '/admin/languages',
  subscriptions: '/subscriptions',
  promoSubscriptionToken: '/subscriptions/promo/:promoSubscriptionToken',
  publicCoupons: '/coupons',
  passwordChange: '/password-change/:token',
  newsletter: '/newsletter',
  openingOffer: '/pasiulymas',
};
